var _classCallCheck = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

// TODO: remove when window.queueMicrotask() is well supported
var queueMicrotask = require('queue-microtask');

var ImmediateStore = /*#__PURE__*/function () {
  "use strict";

  function ImmediateStore(store) {
    _classCallCheck(this, ImmediateStore);

    this.store = store;
    this.chunkLength = store.chunkLength;

    if (!this.store || !this.store.get || !this.store.put) {
      throw new Error('First argument must be abstract-chunk-store compliant');
    }

    this.mem = [];
  }

  _createClass(ImmediateStore, [{
    key: "put",
    value: function put(index, buf, cb) {
      var _this = this;

      this.mem[index] = buf;
      this.store.put(index, buf, function (err) {
        _this.mem[index] = null;
        if (cb) cb(err);
      });
    }
  }, {
    key: "get",
    value: function get(index, opts, cb) {
      if (typeof opts === 'function') return this.get(index, null, opts);
      var memoryBuffer = this.mem[index]; // if the chunk isn't in the immediate memory cache

      if (!memoryBuffer) {
        return this.store.get(index, opts, cb);
      }

      if (opts) {
        var start = opts.offset || 0;
        var end = opts.length ? start + opts.length : memoryBuffer.length;
        memoryBuffer = memoryBuffer.slice(start, end);
      } // queueMicrotask to ensure the function is async


      queueMicrotask(function () {
        if (cb) cb(null, memoryBuffer);
      });
    }
  }, {
    key: "close",
    value: function close(cb) {
      this.store.close(cb);
    }
  }, {
    key: "destroy",
    value: function destroy(cb) {
      this.store.destroy(cb);
    }
  }]);

  return ImmediateStore;
}();

module.exports = ImmediateStore;